'use client';
import { createTheme, ThemeProvider } from '@mui/material';
import { theme } from 'theme/theme';

export const Providers = ({ children }) => (
    <ThemeProvider theme={createTheme(theme)}>
        {children}
    </ThemeProvider>
);
